
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19.983 19.387"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_1229_1","data-name":"Symbol 1229 – 1","transform":"translate(-1237.559 -639.957)","opacity":".74"}},[_c('g',{attrs:{"id":"Icon_1_","transform":"translate(1233.301 640.301)"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Line_2192","d":"M0 0h18.101","data-name":"Line 2192","transform":"translate(5.199 7)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Line_2193","d":"M6.1 6.2L0 0","data-name":"Line 2193","transform":"translate(17.1 .7)"}})]),_c('g',{attrs:{"id":"Icon_1_2","data-name":"Icon_1_","transform":"rotate(180 630.9 329.5)"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Line_2192-2","d":"M0 0h18.101","data-name":"Line 2192","transform":"translate(5.199 7)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Line_2193-2","d":"M6.1 6.2L0 0","data-name":"Line 2193","transform":"translate(17.1 .7)"}})])])])
          )
        }
      }
    